import React, { FC } from 'react';

interface Props {
  className?: string;
}

export const FeelingHappyIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="170"
      height="177"
      viewBox="0 0 170 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M53.8509 177C83.592 177 107.702 175.351 107.702 173.318C107.702 171.284 83.592 169.636 53.8509 169.636C24.1099 169.636 0 171.284 0 173.318C0 175.351 24.1099 177 53.8509 177Z"
        fill="#E6E6E6"
      />
      <path
        d="M75.3199 103.516C75.8484 100.559 78.5843 98.8207 81.3122 98.1252C84.4257 97.3314 87.7446 97.4291 90.9133 97.7872C97.2941 98.5082 103.559 100.457 110.035 100.155C115.665 99.8722 121.122 98.1227 125.861 95.0808C130.627 92.0279 134.469 87.738 136.971 82.6725C139.491 77.5744 140.609 71.9016 140.21 66.2328C140.157 65.528 140.076 64.8262 139.977 64.1265C139.906 63.6259 139.143 63.8389 139.213 64.3363C139.984 69.9724 139.188 75.7112 136.911 80.9275C134.676 86.0907 131.044 90.5332 126.421 93.7587C121.813 96.9658 116.426 98.8855 110.821 99.3186C104.429 99.7837 98.2174 97.9531 91.9353 97.1238C88.7625 96.705 85.5265 96.5489 82.3587 97.098C79.5527 97.5843 76.674 98.8346 75.2336 101.425C74.9054 102.01 74.6765 102.646 74.5562 103.306C74.4675 103.802 75.2305 104.016 75.3199 103.516H75.3199Z"
        fill="#3F3D56"
      />
      <path
        d="M137.003 65.7504C155.227 65.7504 170 51.0317 170 32.8752C170 14.7187 155.227 0 137.003 0C118.779 0 104.006 14.7187 104.006 32.8752C104.006 51.0317 118.779 65.7504 137.003 65.7504Z"
        fill="#3B6EB7"
      />
      <path
        d="M124.596 34.7159C129.262 34.7159 133.044 30.9479 133.044 26.2998C133.044 21.6518 129.262 17.8838 124.596 17.8838C119.931 17.8838 116.149 21.6518 116.149 26.2998C116.149 30.9479 119.931 34.7159 124.596 34.7159Z"
        fill="white"
      />
      <path
        d="M127.243 43.1318C127.312 44.4093 127.87 45.6118 128.801 46.4923C129.733 47.3728 130.967 47.8643 132.251 47.8659H145.978C147.262 47.8643 148.497 47.3728 149.428 46.4923C150.36 45.6118 150.918 44.4093 150.987 43.1318H127.243Z"
        fill="white"
      />
      <path
        d="M121.428 33.5329C123.907 33.5329 125.916 31.5311 125.916 29.0618C125.916 26.5926 123.907 24.5908 121.428 24.5908C118.95 24.5908 116.941 26.5926 116.941 29.0618C116.941 31.5311 118.95 33.5329 121.428 33.5329Z"
        fill="#3F3D56"
      />
      <path
        d="M123.012 28.273C123.596 28.273 124.068 27.802 124.068 27.2209C124.068 26.6399 123.596 26.1689 123.012 26.1689C122.429 26.1689 121.957 26.6399 121.957 27.2209C121.957 27.802 122.429 28.273 123.012 28.273Z"
        fill="white"
      />
      <path
        d="M152.05 34.8477C156.715 34.8477 160.497 31.0797 160.497 26.4317C160.497 21.7836 156.715 18.0156 152.05 18.0156C147.384 18.0156 143.603 21.7836 143.603 26.4317C143.603 31.0797 147.384 34.8477 152.05 34.8477Z"
        fill="white"
      />
      <path
        d="M148.882 33.5329C151.361 33.5329 153.37 31.5311 153.37 29.0618C153.37 26.5926 151.361 24.5908 148.882 24.5908C146.404 24.5908 144.395 26.5926 144.395 29.0618C144.395 31.5311 146.404 33.5329 148.882 33.5329Z"
        fill="#3F3D56"
      />
      <path
        d="M150.466 28.273C151.049 28.273 151.522 27.802 151.522 27.2209C151.522 26.6399 151.049 26.1689 150.466 26.1689C149.883 26.1689 149.41 26.6399 149.41 27.2209C149.41 27.802 149.883 28.273 150.466 28.273Z"
        fill="white"
      />
      <path
        d="M137.531 38.9243C139.28 38.9243 140.699 37.5113 140.699 35.7683C140.699 34.0253 139.28 32.6123 137.531 32.6123C135.782 32.6123 134.363 34.0253 134.363 35.7683C134.363 37.5113 135.782 38.9243 137.531 38.9243Z"
        fill="#3F3D56"
      />
      <path d="M142.283 63.9092H136.475V68.3802H142.283V63.9092Z" fill="#3B6EB7" />
      <path
        d="M58.9355 151.783C58.9355 151.783 62.6619 162.656 61.0649 166.634L65.8559 170.877L68.7838 167.164C68.7838 167.164 65.5898 163.982 65.8559 161.595C66.1221 159.209 66.3883 150.723 66.3883 150.723L58.9355 151.783Z"
        fill="#FFB9B9"
      />
      <path
        d="M76.7673 172.997C76.5497 173.123 76.3422 173.243 76.1513 173.353H59.6307C59.4776 173.266 59.3546 173.135 59.2781 172.976C59.2016 172.818 59.1751 172.64 59.2022 172.466C59.2792 172.073 59.4767 171.272 59.7211 170.352C60.3002 168.174 61.1505 165.322 61.3347 165.626C61.3351 165.626 61.3356 165.626 61.336 165.626C61.3364 165.626 61.3367 165.626 61.337 165.626C61.3374 165.627 61.3376 165.627 61.3378 165.628C61.3379 165.628 61.338 165.628 61.338 165.629C61.5958 166.102 62.1281 168.224 63.4604 167.96C64.7928 167.693 66.9219 167.163 66.9219 167.163C66.9219 167.163 66.162 165.462 66.8884 164.775C67.0446 164.63 67.2425 164.538 67.4542 164.512C69.051 164.248 69.051 166.633 69.051 166.633L74.906 169.815C75.4107 169.954 75.9033 170.133 76.379 170.352C77.5674 170.905 78.7424 171.853 76.7673 172.997Z"
        fill="#2F2E41"
      />
      <path
        d="M48.2887 147.806L41.3683 156.026L39.5051 160.269L41.9006 162.126L44.03 161.33C44.03 161.33 45.8932 156.557 47.7564 155.761C49.6195 154.966 54.1444 149.662 54.1444 149.662L48.2887 147.806Z"
        fill="#FFB9B9"
      />
      <path
        d="M62.795 141.497L59.2656 148.015L56.737 152.683C55.9278 153.163 54.8499 153.155 53.6893 152.871C53.1486 152.733 52.6184 152.557 52.103 152.343C48.9356 151.052 45.7229 148.487 45.7229 148.487L51.8022 140.919L53.7878 138.45L54.259 137.861L56.5294 138.829L60.5352 140.534L62.795 141.497Z"
        fill="#2F2E41"
      />
      <path
        d="M47.0434 85.2101L44.2241 96.732L47.1261 111.514C47.1261 111.514 47.1976 117.557 49.8569 117.098C52.5163 116.64 49.7293 110.545 49.7293 110.545L48.4286 98.4248L52.5875 86.4504C52.9244 85.4804 52.4989 84.4392 51.5231 83.8454C49.8764 82.8434 47.5362 83.5563 47.0434 85.2101Z"
        fill="#FFB9B9"
      />
      <path
        d="M56.9392 75.2765L54.5437 82.7018L50.0188 80.3151C50.0188 80.3151 51.882 75.0113 51.882 74.2158C51.882 73.4202 56.9392 75.2765 56.9392 75.2765Z"
        fill="#FFB9B9"
      />
      <path
        d="M55.0761 78.1935C58.1632 78.1935 60.6657 75.7002 60.6657 72.6246C60.6657 69.549 58.1632 67.0557 55.0761 67.0557C51.9891 67.0557 49.4866 69.549 49.4866 72.6246C49.4866 75.7002 51.9891 78.1935 55.0761 78.1935Z"
        fill="#FFB9B9"
      />
      <path
        d="M56.5401 84.4251L55.4754 83.3643L55.2092 82.0384C55.2092 82.0384 51.749 77.5302 48.8212 79.1214C47.9062 79.6186 47.2252 80.7632 46.7212 82.1021C45.4378 85.6015 45.5575 89.4591 47.0556 92.8728L51.749 103.784L62.3958 102.723L60.5326 95.8282C60.5326 95.8282 62.3958 91.5852 58.9356 88.6681L56.5401 84.4251Z"
        fill="#3B6EB7"
      />
      <path
        opacity="0.3"
        d="M62.7949 141.497L59.2656 148.015L56.7369 152.683C55.9278 153.163 54.8498 153.155 53.6893 152.871C53.487 151.529 54.6954 144.438 53.7452 138.657L53.7878 138.45L54.2589 137.861L56.5293 138.829L60.5352 140.534L62.7949 141.497Z"
        fill="black"
      />
      <path
        d="M62.795 102.061C62.795 102.061 55.8746 97.8179 51.0836 103.122L51.3498 104.713C51.3498 104.713 47.3572 109.221 49.7527 118.768C52.1483 128.314 55.8746 153.242 55.8746 153.242C55.8746 153.242 64.6582 153.772 68.6508 150.855C68.6508 150.855 67.3199 117.972 62.795 114.79V102.061Z"
        fill="#2F2E41"
      />
      <path
        d="M48.3646 87.2904L55.8747 96.4915L69.4493 103.121C69.4493 103.121 74.3248 106.716 75.5652 104.328C76.8056 101.94 70.2478 100.469 70.2478 100.469L59.7692 94.1771L52.7069 83.6392C52.1349 82.7856 51.045 82.4941 49.9805 82.9098C48.1841 83.6114 47.3399 85.8998 48.3646 87.2904Z"
        fill="#FFB9B9"
      />
      <path
        d="M43.3887 160.747C43.3887 160.747 45.0202 158.703 45.9948 159.991C46.9694 161.279 44.8455 162.383 44.8455 162.383L44.7219 169.028C44.7219 169.028 45.8809 174.108 42.7517 172.145C39.6225 170.182 39.4995 169.947 38.8839 168.772C38.2684 167.596 36.9965 162.873 35.8988 161.35C34.8011 159.827 33.7958 156.76 35.0989 156.382C36.4019 156.004 42.4758 154.658 42.1732 155.106C41.8706 155.554 40.2289 157.006 41.0804 158.059C41.9319 159.112 43.3887 160.747 43.3887 160.747Z"
        fill="#2F2E41"
      />
      <path
        d="M58.0034 67.8718C58.0035 67.865 58.004 67.8583 58.004 67.8515C58.004 66.3305 57.5513 64.8437 56.7031 63.579C55.8549 62.3143 54.6494 61.3286 53.2389 60.7465C51.8285 60.1645 50.2765 60.0122 48.7792 60.3089C47.2819 60.6056 45.9065 61.3381 44.827 62.4136C43.7475 63.4891 43.0123 64.8594 42.7145 66.3512C42.4166 67.843 42.5695 69.3893 43.1537 70.7946C43.738 72.1998 44.7273 73.4009 45.9967 74.2459C47.266 75.0909 48.7584 75.542 50.2851 75.542C50.4644 75.542 51.1735 76.8799 51.3497 76.8679C51.3603 72.8085 53.996 68.1444 58.0034 67.8718Z"
        fill="#2F2E41"
      />
      <path
        d="M42.0338 67.0557C44.8268 67.0557 47.091 64.7998 47.091 62.0171C47.091 59.2344 44.8268 56.9785 42.0338 56.9785C39.2408 56.9785 36.9766 59.2344 36.9766 62.0171C36.9766 64.7998 39.2408 67.0557 42.0338 67.0557Z"
        fill="#2F2E41"
      />
      <path
        d="M41.8018 54.3849C43.0204 54.3772 44.2007 54.8089 45.125 55.6002C46.0493 56.3916 46.6552 57.4892 46.831 58.6907C47.0067 59.8922 46.7405 61.1165 46.0814 62.1377C45.4223 63.159 44.4147 63.9084 43.2446 64.2476C43.9691 64.2464 44.6849 64.09 45.3435 63.7891C46.0021 63.4881 46.588 63.0495 47.0615 62.5031C47.535 61.9567 47.885 61.3152 48.0879 60.6222C48.2907 59.9292 48.3416 59.2008 48.2371 58.4865C48.1326 57.7722 47.8752 57.0886 47.4822 56.4821C47.0893 55.8756 46.57 55.3604 45.9597 54.9713C45.3493 54.5823 44.6622 54.3286 43.9448 54.2274C43.2274 54.1263 42.4965 54.1799 41.8018 54.3849Z"
        fill="#2F2E41"
      />
      <path
        d="M53.7451 66.2598H57.7967C58.6988 66.2598 59.5639 66.6168 60.2017 67.2523C60.8395 67.8878 61.1979 68.7497 61.1979 69.6484V71.0331H53.7451V66.2598Z"
        fill="#2F2E41"
      />
    </svg>
  );
};
